export default function Invoices(Restangular) {
  'ngInject';

  Restangular.extendModel('account/org/invoices', (invoice) => {
    if (invoice.issueDate) {
      invoice.issueDate = new Date(invoice.issueDate);
    }

    return invoice;
  });

  return Restangular.service('account/org/invoices');
}
